import React from "react";

import "./logout.css";

function Logout() {

    function logout() {
        sessionStorage.clear();
        window.location.href = "/";
    }

    return (
        <div className="logout-mobile">
            <div className="content-logout-mobile">
                <h1 className="h1-mobile">Logout</h1>
                <div className="logout-quadro-mobile">
                    <p>Tem certeza que deseja sair?</p>
                    <div className="campo-button-logout-mobile">
                        <button className="btn-logout-mobile" onClick={logout}>Sim</button>
                        <button className="btn-logout-mobile" onClick={() => window.location.href = "/"}>Não</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Logout;